import React, { useState, FC } from "react";
import { useStore } from "react-stores";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Slider from "@mui/material/Slider";
import MuiInput from "@mui/material/Input";
import "./input-slider.css";

import { globalStore } from "../../globalStore";
import ProgressBar from "../loaders/ProgressBar";
import { NonSpecificConstruction } from "@malloc-protocol/sdk";
import { UpdateActionNextActionsFn } from "../../interfaces";

interface InputProps {
  nextActions: NonSpecificConstruction["source"]["nextActions"];
  updateNextActions: UpdateActionNextActionsFn;
  outEdgeId: string;
}

export const InputField = styled(MuiInput)`
  width: 100px;
`;

export const InputSlider: FC<InputProps> = (props) => {
  const state = useStore(globalStore);
  const selectedNode = state.context.nodes[state.context.selectedNodeId];
  const edgeObject = selectedNode.outEdges[props.outEdgeId];

  const [value, setValue] = React.useState<
    number | string | Array<number | string>
  >(props.nextActions[props.outEdgeId]);

  // const handleSliderChange = (_event: Event, newValue: number | number[]) => {
  //   setValue(newValue);
  // };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value === "" ? 0 : Number(event.target.value);
    setValue(newValue);

    props.nextActions[props.outEdgeId] = newValue;
    props.updateNextActions(props.nextActions);
  };

  // lower bound at zero
  const handleBlur = () => {
    if (value < 0) {
      setValue(0);
    }
  };

  return (
    <div
      onMouseOver={() => {
        edgeObject.highlighted = true;
      }}
      onMouseOut={() => {
        edgeObject.highlighted = false;
      }}
      className="slider--wrapper"
    >
      <h6 style={{ width: "150px" }}>{props.outEdgeId}</h6>
      <InputField
        value={value}
        size="small"
        onChange={handleInputChange}
        onBlur={handleBlur}
        style={{
          color: "#ffffff",
          minWidth: "120px",
        }}
        inputProps={{
          step: 10,
          min: 0,
          // max: 100,
          type: "number",
          "aria-labelledby": "input-slider",
        }}
      />
      <div style={{ width: "50px" }}>
        <ProgressBar
          value={Number(value) / getNextActionGroupTotal(props.nextActions)}
          min={0}
          max={1}
        />
      </div>
      <button
        className="delete"
        onClick={(_e) => {
          let node1 = edgeObject.node1;
          let node2 = edgeObject.node2;
          let mintIdx = state.context.selectedOutMintIndex;
          delete state.context.nodes[node1.id].outEdges[node2.id];

          if (node1.isSource) {
            delete state.construction.source.nextActions[node2.id];
          } else {
            // @ts-ignore
            delete state.construction.actionDatas[node1.id].action.nextActions[
              mintIdx
            ][node2.id];
          }
          globalStore.setState({
            ...state,
          });
        }}
      >
        x
      </button>
    </div>
  );
};

const getNextActionGroupTotal = (
  group: NonSpecificConstruction["source"]["nextActions"]
) => {
  return Object.keys(group).reduce(
    (prev: number, curr: string) => prev + group[curr],
    0
  );
};

// no-slider input group
// uses progress bars as read only view of inputs
const InputGroup = (props: {
  updateNextActions: UpdateActionNextActionsFn;
  nextActions: NonSpecificConstruction["source"]["nextActions"];
}) => {
  return (
    <div>
      {Object.keys(props.nextActions).map((action: string) => {
        return (
          <InputSlider
            outEdgeId={action}
            nextActions={props.nextActions}
            updateNextActions={props.updateNextActions}
          />
        );
      })}
    </div>
  );
};

export default InputGroup;
